import clsx from "clsx";
import ErrorIcon from "@mui/icons-material/Error";
import CheckIcon from "@mui/icons-material/Check";
import NormalText from "components/Typography/NormalText";
import { styled } from "@mui/material";

const ContainerStyled = styled("div")({
  borderRadius: "10px",
  padding: "10px",
  display: "flex",
  gap: "10px",
  alignItems: "center",
  "&.banner-success": {
    backgroundColor: "#c1dcc0",
    color: "#234722",
    "& p": {
      color: "#234722",
    },
  },
  "&.banner-error": {
    backgroundColor: "#f0c2ba",
    color: "#963120",
    "& p": {
      color: "#963120",
    },
    "& .icon": {
      color: "#963120",
      fill: "#963120",
    },
  },
});

const Banner = ({ className, children, type, text }) => {
  return (
    <ContainerStyled
      className={clsx(
        { "banner-success": type === "success" },
        { "banner-error": type === "error" },
        className
      )}
    >
      {type === "success" && <CheckIcon fontSize="medium" className="icon" />}
      {type === "error" && <ErrorIcon className="icon" />}
      {text ? <NormalText>{text}</NormalText> : children}
    </ContainerStyled>
  );
};

const BannerSuccess = ({ children, className, text }) => {
  return (
    <Banner type="success" className={className} text={text}>
      {children}
    </Banner>
  );
};
const BannerError = ({ children, className, text }) => {
  return (
    <Banner type="error" className={className} text={text}>
      {children}
    </Banner>
  );
};

Banner.Success = BannerSuccess;
Banner.Error = BannerError;

export default Banner;
